module.exports = __webpack_public_path__ + "static/media/cypress-eco-ecology-svgrepo-com.8056d536.svg";